import React from "react";
import styled from "styled-components";
import content from "../../content";
import { Link } from "react-router-dom";
import f from "../../assets/icons/f.png";
import { Divider } from "@material-ui/core";
import LangPicker from "./LangPicker";

const UtilityWrapper = styled.div`
  height: 41px;
  min-height: 41px;
  background: #ebebeb;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const StyledLink = styled(Link)<{ red?: boolean }>`
  font-size: 12px;
  margin: 0 25px;
  color: ${({ red }) => (red ? "#C41230" : "inherit")};
`;

function stop(e) {
  e.stopPropagation()
  e.preventDefault()
}

function UtilityHeader({}: IUtilityHeader) {
  return (
    <UtilityWrapper>
      <StyledLink to={"#"} onClick={stop} red={true}>
        {content.getValue("header_download_doc")}
      </StyledLink>
      <StyledLink to={"#"} onClick={stop}>{content.getValue("header_ue_dotation")}</StyledLink>
      <StyledLink to={"#"} onClick={stop}>{content.getValue("header_eu_zone")}</StyledLink>
      <Divider
        style={{ height: "60%" }}
        light={true}
        orientation={"vertical"}
      />
      <StyledLink to={"#"}>
        <img style={{ marginTop: "6px" }} src={f} />
      </StyledLink>
      <Divider
        style={{ height: "60%" }}
        light={true}
        orientation={"vertical"}
      />
      <LangPicker />
    </UtilityWrapper>
  );
}

export interface IUtilityHeader {}

export default UtilityHeader;
